import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconSplit$1 = /*@__PURE__*/ proxyCustomElement(class WppIconSplit extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
    this.direction = 'horizontal';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-split", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.2007 11.6003L9.13341 11.5422C8.89852 11.3679 8.56519 11.3872 8.35217 11.6003L8.00102 11.9514L8.00083 8.80059L12.0006 8.80059L12.0008 11.9529L11.5912 11.6004L11.5239 11.5423C11.289 11.368 10.9557 11.3873 10.7426 11.6003C10.5083 11.8345 10.5082 12.2144 10.7425 12.4488L12.1755 13.825L12.2428 13.8831C12.4777 14.0574 12.8111 14.0381 13.0242 13.825L14.4003 12.4489L14.4583 12.3817C14.6326 12.1468 14.6133 11.8134 14.4003 11.6004L14.333 11.5423C14.0981 11.368 13.7647 11.3874 13.5517 11.6004L13.2008 11.9513L13.2005 8.19956L13.1951 8.11814C13.1553 7.82528 12.9043 7.59956 12.6005 7.59956L12.5853 7.60059H10.6005L10.6003 4.99956L10.5949 4.91814C10.5551 4.62528 10.3041 4.39956 10.0003 4.39956L9.91891 4.40504C9.62605 4.44477 9.40033 4.6958 9.40033 4.99956L9.40054 7.60059H7.43532C7.42389 7.59994 7.41237 7.59961 7.40078 7.59961L7.31937 7.60509C7.0265 7.64482 6.80078 7.89585 6.80078 8.19961L6.80102 11.953L6.44931 11.6003L6.38203 11.5422C6.14717 11.3678 5.81384 11.3871 5.60078 11.6001C5.36642 11.8344 5.36635 12.2143 5.60062 12.4486L6.97578 13.825L7.04307 13.8831C7.27796 14.0575 7.61135 14.0381 7.82439 13.8251L9.2007 12.4488L9.25879 12.3815C9.43308 12.1466 9.41371 11.8133 9.2007 11.6003ZM2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10ZM16.8 10C16.8 13.7555 13.7555 16.8 10 16.8C6.24446 16.8 3.2 13.7555 3.2 10C3.2 6.24446 6.24446 3.2 10 3.2C13.7555 3.2 16.8 6.24446 16.8 10Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-split-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-split", "wpp-icon-split-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1],
    "direction": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-split-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-split-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconSplit$1);
      }
      break;
  } });
}

const WppIconSplit = WppIconSplit$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconSplit, defineCustomElement };
